import { Controller, useForm } from "react-hook-form";
import MultiSelectionField from "../../../../CommonElements/Form/MultiSelectionField";
import { InputField } from "../../../../CommonElements";
import { Button, Form } from "reactstrap";
import { useEffect, useState } from "react";
import useAxios from "../../../../Utils/useAxios";
import getPermission from "../services/getPermission";
import getUserList from "../services/getUserList";
import createGroupRole from "../services/createGroupRole";
import updateGroupRole from "../services/updateGroupRole";

const AdminForm = ({ resetState, toggle, data }) => { 
  const [permission, setPermission] = useState({});
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const axiosInstance = useAxios();
  
  // Ensure each item has proper format with group and name properties
  const formatItemWithGroup = (item, groupName) => {
    if (!item) return null;
    
    return {
      ...item,
      id: item.id,
      name: item.name || item.nama || "Unknown",
      group: groupName
    };
  };
  
  // Format default values with proper group information
  const formattedPermissions = data && data.permissions 
    ? data.permissions.map(p => formatItemWithGroup(p, "Permissions"))
    : [];
  
  const formattedUsers = data && data.users 
    ? data.users.map(u => formatItemWithGroup(u, "User"))
    : [];
  
  const { control, handleSubmit, setValue, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      name: data ? data.name : "",
      permissions: [],
      users: []
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await refreshRole();
      
      if (data) {
        setValue("permissions", formattedPermissions);
        setValue("users", formattedUsers);
      }
      
      setLoading(false);
    };
    
    fetchData();
  }, [data]);

  const refreshRole = async () => {
    try {
      const permRes = await getPermission(axiosInstance);
      setPermission({ Permissions: permRes.data });
      
      const userRes = await getUserList(axiosInstance);
      setUser({ User: userRes.data });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onSubmit = async (formData) => {
    const formattedData = {
      ...formData,
      permissions: formData.permissions.map(permission => permission.id),
      users: formData.users.map(user => user.id),
    };
    console.log("Submitting:", formattedData);
    
    try {
      if (data?.id) {
        await updateGroupRole(axiosInstance, data.id, formattedData);
      } else {
        await createGroupRole(axiosInstance, formattedData);
      }
      resetState();
      toggle();
    } catch (error) {
      console.error('Error saving group:', error);
    }
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="name"
        control={control}
        rules={{ required: "Name is required" }}  
        render={({ field, fieldState }) => (
          <InputField
            label="Role"
            fieldState={fieldState}
            {...field}
            isRequired
          />
        )}
      />
      <Controller
        name="permissions"
        control={control}
        rules={{ required: "Permission is required" }}  
        render={({ field, fieldState }) => (
          <MultiSelectionField
            label="Permission"
            options={permission}
            fieldState={fieldState}
            {...field}
            isRequired={true}
            defaultChecked={formattedPermissions}
          />
        )}
      />
      <Controller
        name="users"
        control={control}
        rules={{ required: "User is required" }}  
        render={({ field, fieldState }) => (
          <MultiSelectionField
            label="User"
            options={user}
            fieldState={fieldState}
            {...field}
            isRequired={true}
            defaultChecked={formattedUsers}
          />
        )}
      />
      <Button color="primary">Save</Button>
    </Form>
  );
}

export default AdminForm;